import styled from 'styled-components';
import { theme } from '@/theme/Theme';

// 帳戶內頁共用白底區塊：與訂閱明細同一套標題、連結、提示與表格樣式。
export const Panel = styled.section({
  background: theme.colors.light,
  borderRadius: theme.radii.lg,
  padding: '24px 32px',
  marginBottom: '24px',
  color: '#242b3a',
  fontSize: theme.fontSizes.base,
  lineHeight: 1.6,
  minWidth: 0,
  '& > :first-child': { marginTop: 0 },
  '& p': { margin: '0 0 12px' },
  '& h2': { margin: '0 0 12px', fontSize: '24px', lineHeight: 1.35, color: '#182d58', fontWeight: 700 },
  '& h3': { margin: '24px 0 12px', fontSize: '20px', lineHeight: 1.4, color: '#182d58', fontWeight: 700 },
  '& a:not(.action-link)': { color: theme.colors.primary500, textDecoration: 'underline', textUnderlineOffset: '4px' },
  '& .intro': { color: '#596579' },
  '& .fields': { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '20px', marginBottom: '24px' },
  '& .wide': { gridColumn: '1 / -1' },
  '& .consent-fields': { display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' },
  '& .consent-fields .MuiFormControlLabel-root': { margin: 0, alignItems: 'flex-start' },
  '& .consent-fields .MuiFormControlLabel-label': { fontSize: 'inherit', lineHeight: 1.6, paddingTop: '8px' },
  '& .consent-fields .MuiCheckbox-root': { marginLeft: '-9px', flexShrink: 0 },
  '& .upload-field': {
    border: '1px dashed #8b98ac',
    borderRadius: theme.radii.base,
    padding: '16px',
    minWidth: 0,
    overflowWrap: 'anywhere',
    position: 'relative',
  },
  '& .upload-field:focus-within': { outline: `2px solid ${theme.colors.primary500}`, outlineOffset: '3px' },
  '& .visually-hidden-input': {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
    border: 0,
  },
  '& .actions': { display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginTop: '24px' },
  '& .scroll': { overflowX: 'auto', width: '100%' },
  '& table': { borderCollapse: 'collapse', width: '100%' },
  '& th, & td': { textAlign: 'left', padding: '12px', borderBottom: '1px solid #e1e5ec', verticalAlign: 'top' },
  '& thead th': { background: '#f5f7fc', color: '#344158', fontWeight: 600 },
  '& tbody th': { fontWeight: 600 },
  '& button': { minHeight: '44px', height: 'auto', whiteSpace: 'normal' },
  '& ul': { margin: '0 0 16px', paddingLeft: '24px' },
  '& li': { margin: '4px 0' },
  '& details': { margin: '8px 0' },
  '& summary': { cursor: 'pointer' },
  '& .status': {
    display: 'inline-block',
    color: theme.colors.primary500,
    background: '#eef3ff',
    borderRadius: theme.radii.base,
    padding: '2px 12px',
    fontWeight: 700,
  },
  '& .notice': { background: '#f5f7fc', borderLeft: `3px solid ${theme.colors.primary500}`, padding: '12px 16px' },
  '& .error': {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
    color: '#9f1b1b',
    background: '#fdf3f3',
    borderLeft: '3px solid #9f1b1b',
    padding: '12px 16px',
  },
  '& .summary': {
    display: 'grid',
    gridTemplateColumns: 'minmax(140px, max-content) minmax(0, 1fr)',
    gap: '8px 32px',
    margin: '0 0 16px',
    padding: '16px 20px',
    border: '1px solid #e1e5ec',
    borderRadius: theme.radii.base,
  },
  '& .summary dt': { color: '#596579' },
  '& .summary dd': { margin: 0, fontVariantNumeric: 'tabular-nums' },
  '& .summary .total': { paddingTop: '8px', borderTop: '1px solid #e1e5ec', fontWeight: 700, color: '#182d58' },
  '@media (max-width: 640px)': {
    padding: '16px',
    '& .fields': { gridTemplateColumns: '1fr' },
    '& .summary': { gridTemplateColumns: '1fr', gap: '4px' },
    '& .summary .total': { paddingTop: 0, borderTop: 0 },
    '& th, & td': { padding: '8px' },
  },
});
